export const INPUT_TYPES = {
  date: 'date',
  duration: 'duration',
  list: 'list',
  scale: 'scale',
  text_long: 'text_long',
  text_short: 'text_short',
};



// WEBPACK FOOTER //
// ./src/js/forms/enums/InputTypes.js